import { Spacer } from 'app/member/layouts/generic';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CampaignInformation } from './info';
import { CampaignPageStatBar } from './statbar';

export const CampaignPage = () => {
  const { id } = useParams();

  return (
    <>
      <CampaignPageStatBar id={id} />
      <Spacer multiple={4} />
      <CampaignInformation id={id} />
    </>
  );
};
